import { useEffect, useRef, useState } from "react";
import Heading from "../heading/heading";
import styles from "./home-news.module.css";
import { getNewsList } from "../../services/news/news.service";
import FirstNews from "../product/FirstNews";
import NewsBar from "../product/NewsBar";
export default function HomeNews() {
  const ref = useRef();
  const [slideCount, setSlideCount] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);
  const [offsetHeight, setOffsetHeight] = useState(0);
  const [news, setNews] = useState([]);
  useEffect(() => {
    getNewsList().then(({ data }) => {
      const tempNews = (data && data.data).slice(0, 16);
      setNews(tempNews);
      setSlideCount(Math.floor(tempNews.length / 3));
    });
  }, []);
  useEffect(() => {
    if (Array.isArray(news) && news.length > 0) {
      setOffsetHeight(ref.current.offsetHeight / (news.length - 1));
    }
  }, [news]);
  const handleNext = () => {
    setSlideIndex(slideIndex + 1);
  };
  const handlePrev = () => {
    setSlideIndex(slideIndex - 1);
  };
  return (
    <div className={styles.newsSectionContainer}>
      <div className="container">
        <Heading title={"اخبار"} icon="fa fa-rss" more={"/news/list"}></Heading>
        <div className="row">
          <div className="col-xs-12 col-md-6 pull-right">
            {Array.isArray(news) && news.length > 0 ? (
              <div className="row">
                <div className="col-xs-12 col-md-12 pull-right">
                  <FirstNews news={news[0]} />
                </div>
              </div>
            ) : (
              <div className="loading-wrapper">
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
          <div className="col-xs-12 col-md-6 pull-left">
            <div className="row">
              <div
                id="newsCarousel"
                className="carousel vertical slide"
                data-ride="carousel"
                data-type="multi"
                data-interval="false"
              >
                <div className="carousel-inner">
                  <div
                    ref={ref}
                    className={styles.carouselInner}
                    style={{
                      position: "relative",
                      top: slideIndex * (-3 * offsetHeight),
                    }}
                  >
                    {news.slice(1).map((el, key) => (
                      <NewsBar
                        ref={ref}
                        key={`main-page-news-el-${key}`}
                        news={el}
                      />
                    ))}
                  </div>
                </div>
                <div className={styles.arrows}>
                  <button
                    className="left carousel-control"
                    disabled={slideIndex === 0 ? "disabled" : false}
                    onClick={() => handlePrev()}
                  >
                    <i className="fa fa-angle-up" />
                  </button>
                  <button
                    className="right carousel-control"
                    disabled={
                      slideIndex === slideCount - 1 ? "disabled" : false
                    }
                    onClick={() => handleNext()}
                  >
                    <i className="fa fa-angle-down" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
